import { AUTH_CHECK, AUTH_ERROR, AUTH_GET_PERMISSIONS, AUTH_LOGIN, AUTH_LOGOUT } from "react-admin";
import { decode } from "jsonwebtoken";
import { userService } from "../services/UserService";

const setToken = (token) => {
    localStorage.setItem("token", token);
    userService.onLoginResponse({ authenticated: true, token });
    userService.authToken = token;
};

const resolveUser = () => {
    const token = localStorage.getItem("token");
    if (!token) {
        userService.logout();
        return false;
    }

    const decoded = decode(token);
    if (!decoded || decoded.exp * 1000 < Date.now()) {
        userService.logout();
        return false;
    }

    setToken(token);
    localStorage.setItem("user", JSON.stringify(decoded));
    return true;
};

export default function AuthProvider(type, params) {
    switch (type) {
        // called when the user attempts to log in
        case AUTH_LOGIN: {
            const { token } = params;
            setToken(token);
            const user = resolveUser();
            return user ? Promise.resolve() : Promise.reject();
        }
        case AUTH_LOGOUT:
            userService.logout();
            return Promise.resolve();

        case AUTH_ERROR:
            if (params.status === 401) {
                return Promise.reject();
            }
            return Promise.resolve();

        // Called on every route change to verify the session is still valid
        case AUTH_CHECK: {
            const user = resolveUser();
            return user ? Promise.resolve() : Promise.reject({ message: false });
        }
        // Called by usePermissions() to gate UI elements and route access based on token permissions
        case AUTH_GET_PERMISSIONS: {
            const user = resolveUser();
            if (!user) return Promise.reject({ message: false });
            const decoded = decode(localStorage.getItem("token"));
            return Promise.resolve(decoded?.permissions || []);
        }

        default:
            return Promise.reject(new Error(`AuthProvider: unknown method ${type}`));
    }
}
